import { useTranslation } from 'react-i18next';

import { Button } from '@any-ui-react/core';

export const CustomerActivityTimelineError = ({ onReload }: { onReload?: () => void }) => {
  const { t } = useTranslation('shared');
  return (
    <div className="flex h-20 w-full flex-col items-center justify-center gap-y-1 p-1">
      <p className="text-sm">{t('shared.alert.error.default')}</p>
      {onReload && (
        <Button variant="default" onClick={onReload}>
          {t('shared.button.reload')}
        </Button>
      )}
    </div>
  );
};
